module.exports = __webpack_public_path__ + "static/media/se05.355eb8df.jpg";